import memoize from "memoize-one";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactWebChat, {
  createDirectLine,
  createStore,
} from "botframework-webchat";
// import { InputText } from '../formComponents/inputText'
import PropTypes from "prop-types";
import domtoimage from "dom-to-image";
import PasswordInput from "../PasswordInputComponent/PasswordInput";
import ActivityWithNoAvatar from "../ActivityWithNoAvatar";
import {
  getLoginMessage,
  getLoginRetryMessage,
} from "../../shared/conversationConsts";
import "./WebChat.css";
import loader from "../../assets/images/loader.svg";
import { getWebChatStyleSet } from "../../shared/createStyleSet";
import { downscaleImage } from "../../shared/imageDownscalar";
import {
  createCognitiveServicesSpeechServicesPonyfillFactory,
  createBrowserWebSpeechPonyfillFactory,
} from "botframework-webchat";
import directLineDisconnect from "botframework-webchat-core/lib/actions/disconnect";
import ConnectedCard from "../ConnectedCardComponent/ConnectedCardComponent";
import Thumbs from "../ThumbsComponent/ThumbsComponent";
// import CustomActivityHandler from '../HandlerComponent/customActivityHandler';
import Loading from "../Loading/Loading";
import ModalConfirm from "../CloseModalConfirm/ModalConfirm";
const DirectLineConnectionStatus = {
  Uninitialized: 0,
  Connecting: 1,
  Online: 2,
  ExpiredToken: 3,
  FailedToConnect: 4,
  Ended: 5,
};

class WebChat extends Component {
  constructor(props) {
    super(props);
    this.showLoader();
    const searchParameters = props.searchParameters;

    this.state = {
      searchParameters,
      ccv: null,
      cardNo: null,
      date: null,
      openModal: false,
      isSubMenu: false,
      isConfirmActions: false,
      lastActivity: {
        resources: null,
        role: null,
        suggestedActionsResources: null,
      },
    };
    localStorage.removeItem("lastActivityTime");
    this.checkSessionValidity();
    const store = this.getStore();

    this.createDirectLine = memoize((token) =>
      createDirectLine({ token, locale: "en-us" })
    );
    const styleSet = getWebChatStyleSet(
      this.props.webChatConfiguration,
      this.props.language
    );

    const { connectToWebChat } = window.WebChat;

    var isConnectedVisible = false;
    var thumbsActivityId;
    var connectedToAgentId;
    var SubMenuId;
    const setActivityRoles = (resources, suggestedActionsResources, role) => {
      this.setState({
        lastActivity: {
          resources: resources,
          role: role,
          suggestedActionsResources: suggestedActionsResources,
        },
      });
    };

    const ConnectedPasswordInputActivity = connectToWebChat(
      ({ postActivity }) => ({ postActivity })
    )((props) => <PasswordInput {...props} />);

    const WithoutAvatarActivity = connectToWebChat(({ postActivity }) => ({
      postActivity,
    }))((props) => <ActivityWithNoAvatar {...props} />);

    let showAvatar = true;
    let previousMessageFrom = "";
    this.hasSubmittedPassword = false;

    const activityMiddleware = () => (next) => (card) => {
      if (card.activity.type === "message") {
        this.setState({ isRestartClick: false });
        localStorage.setItem("lastActivityTime", Date.now());
        localStorage.setItem("lastActivityTimeThenClearSession", Date.now());
        if (
          card.activity.attachments &&
          card.activity.attachments.length &&
          card.activity.attachments[0].content &&
          card.activity.attachments[0].content.body &&
          card.activity.attachments[0].content.body.length &&
          card.activity.attachments[0].contentType ===
            "application/vnd.microsoft.card.adaptive"
        ) {
          let self = this;
          for (
            let i = 0;
            i < card.activity.attachments[0].content.body.length;
            i++
          ) {
            if (
              card.activity.attachments[0].content.body[i].type === "Image" &&
              card.activity.attachments[0].content.body[i].url.split(
                "###"
              )[0] === "PAYMENT"
            ) {
              let cardInfo = card.activity.attachments[0].content.body[
                i
              ].url.split("###");
              this.setState(
                {
                  ccv: cardInfo[1],
                  cardNo: cardInfo[2],
                  date: cardInfo[3],
                  name: cardInfo[4],
                },
                () => {}
              );
              card.activity.attachments[0].content.body[i].url =
                "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ1Tort3a_IQFnYdmtLtmU7rEMJGz8Lsc5soA&usqp=CAU";
              setTimeout(() => {
                this.adjustImage();
              }, 0);
            }
          }

          setTimeout(() => {
            if (self) {
              self.adjustInputField();
              self.adjustCheckbox();
              return next(card);
            }
          }, 0);
        }
        let resource = null;
        let suggestedActionsResources = null;
        if (card.activity?.value) {
          resource = card?.activity?.value?.activityResources;
          suggestedActionsResources =
            card?.activity?.value?.suggestedActionsResources;
        }
        setActivityRoles(
          resource,
          suggestedActionsResources,
          card?.activity?.from?.role
        );
        if (
          card.activity.from.role === "bot" &&
          (card.activity.text === getLoginMessage(this.props.language) ||
            card.activity.text === getLoginRetryMessage(this.props.language))
        ) {
          if (
            !this.hasSubmittedPassword &&
            card.activity.text === getLoginRetryMessage(this.props.language)
          ) {
            card.activity.text =
              "Please provide the password in the password field!";
            this.hasSubmittedPassword = true;
          }
          return next(card);
        }
        if (
          card.activity.attachments &&
          card.activity.attachments[0] &&
          card.activity.attachments[0].contentUrl === ""
        ) {
          card.activity.attachments[0].contentUrl = "/";
        }
        if (
          card.activity.from.role === "user" &&
          card.activity.channelData.state === "send failed"
        ) {
          card.activity.channelData.state = "sent";
        }
        if (
          card.activity.value &&
          card.activity.value.Id === "ThumbsActivity"
        ) {
          card.activity.speak = " ";
          return (children) => (
            <div className="thumbsTime">
              <Thumbs
                sendMessage={this.sendMessage}
                sendThumbsUpMessage={this.sendThumbsUpMessage}
              />
            </div>
          );
        }
        if (
          card.activity.value &&
          card.activity.value.Id === "ConnectedToAgent"
        ) {
          this.props.handleDequeued(null);
          return (children) => (
            <div>
              <ConnectedCard
                sendMessage={this.sendMessage}
                text={card.activity.text}
              />
            </div>
          );
        }
        if (card.activity.value && card.activity.value.Id === "SubMenu")
          this.setState({ isSubMenu: true });
        if (card.activity.value && card.activity.value.Id === "ConfirmActions")
          this.setState({ isConfirmActions: true });

        const currentMessageFrom = card.activity.from.role;
        showAvatar =
          previousMessageFrom !== currentMessageFrom ||
          previousMessageFrom === "";
        previousMessageFrom = currentMessageFrom;
        return next(card);
      }

      return next(card);
    };
    let disabled = false;
    let token = localStorage.getItem("botToken");

    let sendOnMount = false;
    window.addEventListener(
      "RequestAgent",
      this.RequestAgentHandler.bind(this),
      false
    );

    let listening = false;
    let isRestartClick = true;
    let isLoading = false;
    this.state = {
      activityMiddleware,
      store,
      token,
      sendOnMount,
      disabled,
      listening,
      isRestartClick,
      isLoading,
    };
    this.startSendHeartBeat();
  }

  rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  openModalFun = () => {
    this.setState({ openModal: true });
  };

  closeModalFun = () => {
    this.SendWelcome = false;
    this.setConversationAsAbandon();
    this.setState({
      token: null,
      showedIntroCard: false,
      welcomedUser: false,
    });
    this.disconnectChatbotHandler();

    if (localStorage.getItem("botToken")) {
      localStorage.removeItem("botToken");
      localStorage.removeItem("preflightSent");
      localStorage.removeItem("conversationId");
    }
    //
    this.SendEncryptedCodeStartUp();
    window.location.reload();
    // this.setLinkOnClick();
    this.setState({ openModal: false });
  };
  // Send Message
  sendMessage = (text) => {
    this.setState({ disabled: false }, async () => {
      var eventObj = {
        type: "WEB_CHAT/SEND_MESSAGE",
        payload: {
          name: "message",
          value: { language: this.props.language },
          language: this.props.language,
          text: text,
        },
        locale: this.props.language,
      };
      this.state.store.dispatch(eventObj);
      this.setState(() => ({ submitted: true }));
    });
  };

  // Send Thumbs Up Message
  sendThumbsUpMessage = async (e) => {
    var eventObj = {
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "webchat/thumbsUp",
        value: { language: this.props.language },
        language: this.props.language,
      },
      locale: this.props.language,
    };

    this.state.store.dispatch(eventObj);
  };

  RequestAgentHandler = async (e) => {
    var eventObj = {
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "handoff/CreateRequest",
        value: { language: this.props.language },
        language: this.props.language,
      },
      locale: this.props.language,
    };

    this.state.store.dispatch(eventObj);
  };

  checkQueuePosition = () => {
    this.setState({ disabled: false }, async () => {
      var eventObj = {
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "handoff/QueuePosition", //  'webchat/getQueue'
          value: { language: this.props.language },
          language: this.props.language,
        },
        locale: this.props.language,
      };

      this.state.store.dispatch(eventObj);
    });
  };
  getCustomerCodeAndSendIt = async () => {
    // localStorage.setItem(
    //   "userInfo",
    // JSON.stringify({
    //   mobile: "12345678",
    //   name: "ahmed",
    //   email: "ahmedhassan@blackstoneeit.com",
    // });
    // );
    if (localStorage.getItem("userInfo")) {
      //console.log("hello from send start")
      const data = localStorage.getItem("userInfo");
      this.setState({ disabled: false }, async () => {
        var eventObj = {
          type: "WEB_CHAT/SEND_EVENT",
          payload: {
            name: "webchat/user-data", //  'webchat/getQueue'
            value: {
              language: this.props.language,
              ...JSON.parse(data),
            },
            language: this.props.language,
          },
          locale: this.props.language,
        };

        this.state.store.dispatch(eventObj);
      });
    }
  };
  setConversationAsAbandon = () => {
    // this.endConversationHandler();
    this.setState({ disabled: false }, async () => {
      var eventObj = {
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "conversation/Abandon", //  'Abandon'
          value: { language: this.props.language },
          language: this.props.language,
        },
        locale: this.props.language,
      };

      this.state.store.dispatch(eventObj);
    });
  };
  checkSessionValidity() {
    setInterval(() => {
      const last = localStorage.getItem("lastActivityTime");
      if (last && +last + 10 * 60 * 1000 < Date.now()) {
        this.openModalFun();
      }
      if (last && +last + 20 * 60 * 1000 < Date.now()) {
        this.closeModalFun();
      }
    }, 1000 * 60);
  }
  startSendHeartBeat = () => {
    setInterval(() => {
      var eventObj = {
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "conversation/heartbeat",
        },
      };
      this.state.store.dispatch(eventObj);
    }, 30000);
  };
  sendTranscript = () => {
    this.setState({ disabled: false }, async () => {
      var eventObj = {
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/sendTranscript",
          value: { language: this.props.language },
          language: this.props.language,
        },
        locale: this.props.language,
      };

      this.state.store.dispatch(eventObj);
    });
  };

  count = 0;

  SendEncryptedCodeStartUp = (e) => {
    //console.log("hello from send start")
    this.setState({ disabled: true }, async () => {
      var eventObj = {
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/join", //  'webchat/getQueue'
          value: { language: this.props.language },
          language: this.props.language,
        },
        locale: this.props.language,
      };

      this.state.store.dispatch(eventObj);
    });
    this.getCustomerCodeAndSendIt();
  };

  SendEncryptedCodeEnd = async (e) => {
    await this.SendEncryptedCode("webchat/end_join");
  };

  SendEncryptedCodeNewAccount = async (e) => {
    await this.SendEncryptedCode("webchat/be_token_received");
  };

  SendEncryptedCode = async (eventName) => {
    this.setState({ disabled: true }, async () => {
      var eventObj = {
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: eventName,
          value: { language: this.props.language },
          language: this.props.language,
        },
        locale: this.props.language,
      };

      this.state.store.dispatch(eventObj);
    });
  };

  // Disconnect Chatbot Handler
  disconnectChatbotHandler = (removeHistory = true) => {
    if (removeHistory) {
      const lis = document.querySelectorAll("li[role='listitem']");
      for (let index = 0; index < lis.length; index++) {
        lis[index].remove();
      }
    }
    console.log(removeHistory, "lissss");

    setTimeout(() => {
      this.state.store.dispatch(directLineDisconnect());
    }, 1000);
  };
  // Get Store
  getStore = () => {
    const store = createStore(
      {},
      ({ dispatch }) => (next) => async (action) => {
        // console.log(action.payload?.activity?.value, "action");

        switch (action.type) {
          case "DIRECT_LINE/CONNECT_FULFILLED":
            setTimeout(() => {
              let messages = Array.from(document.getElementsByTagName("li"));
              if (!messages || messages.length === 0) {
                this.SendEncryptedCodeStartUp();
                localStorage.setItem("preflightSent", true);
              }
            }, 500);
            break;
          case "WEB_CHAT/MARK_ACTIVITY":
            if (action.payload && action.payload.name === "speak") {
              // if (action.payload.value) {
              // 	if (!document.getElementsByClassName("gif_player")[0].classList.contains("playing")) {
              // 		document.getElementsByClassName("gif_player")[0].classList.add("playing");
              // 		document.getElementsByClassName("gif_player")[0].getElementsByTagName('img')[0].src = "../../assets/images/avatar.gif";
              // 	}
              // } else if (document.getElementsByClassName("gif_player")[0].classList.contains("playing")) {
              // 	document.getElementsByClassName("gif_player")[0].classList.remove("playing");
              // 	document.getElementsByClassName("gif_player")[0].getElementsByTagName('img')[0].src = "../../assets/images/avatar_preview.gif";
              // }
            }
            break;
          case "WEB_CHAT/SET_LANGUAGE":
            action.payload.language = this.props.language;
            break;
          case "WEB_CHAT/SEND_MESSAGE":
            // Check if message contains only whitespaces; drop message if it does
            if (!action.payload.text.replace(/\s/g, "").length) {
              return;
            }
            break;
          case "DIRECT_LINE/POST_ACTIVITY":
            if (
              action.payload.activity &&
              action.payload.activity.attachments &&
              action.payload.activity.channelData &&
              action.payload.activity.channelData.attachmentSizes &&
              action.payload.activity.channelData.attachmentSizes.some(
                (x) => x > 2000000
              )
            ) {
              dispatch({
                type: "DIRECT_LINE/INCOMING_ACTIVITY",
                payload: {
                  activity: {
                    id: new Date().toISOString(),
                    channelId: "directline",
                    from: {
                      id: "LocalAttachmentValidation",
                      name: "Blackstone Bot",
                      role: "bot",
                    },
                    timestamp: new Date().toISOString(),
                    text: this.props.literals.attachmentSizeValidationMessage,
                    inputHint: "expectingInput",
                    locale: this.props.language,
                    type: "message",
                  },
                },
              });
              return;
            }

            if (action.payload.activity.type === "message") {
              if (action.payload?.activity?.value?.id == "RateChoic") {
                // console.log(action, "action 2");

                if (
                  action.payload?.activity?.value.id !== "InputFeedback" &&
                  action.payload?.activity?.value.id !== "InputFeedbackWeb"
                ) {
                  // console.log("action.payload.activity", action.payload);

                  this.disableSendBtn();
                  this.disableAllButtons();
                }
              }

              this.disableAllButtons();
            }
            if (
              action.payload.activity &&
              action.payload.activity.attachments
            ) {
              const downscaledImages = await Promise.all(
                action.payload.activity.attachments.map(
                  ({ contentType, contentUrl }) =>
                    /^image\//.test(contentType)
                      ? downscaleImage(contentUrl, contentType, 480)
                      : null
                )
              );
              (
                action.payload.activity.channelData ||
                (action.payload.activity.channelData = {})
              ).thumbnails = downscaledImages;
            }

            break;
          case "DIRECT_LINE/INCOMING_ACTIVITY":
            const { activity } = action.payload;
            if (
              activity &&
              activity.type === "message" &&
              activity.from.role === "bot"
            ) {
              this.playReceivedMessageSound();
              if (
                action.payload.activity.value &&
                action.payload.activity.value.Id === "ThumbsActivity"
              )
                this.thumbsActivityId = "ThumbsActivity";
              if (
                action.payload.activity.value &&
                action.payload.activity.value.Id === "ConnectedToAgent"
              )
                this.connectedToAgentId = "ConnectedToAgent";
              if (
                action.payload.activity.value &&
                action.payload.activity.value.Id === "SubMenu"
              )
                this.SubMenuId = "SubMenu";
              if (activity.locale) {
                setTimeout(() => {
                  this.checkLanguageDirection(activity.locale);
                }, 100);
              }
            }

            if (activity.type === "event") {
              if (activity.action && activity.action === "openUrl") {
                console.log("activity from openUrl ", activity);
                window.open(activity.channelData);
              }
              if (
                activity.name === "webchat/request_be_token" &&
                activity.from.role === "bot"
              ) {
                if (!localStorage.getItem("preflightSent")) {
                  localStorage.setItem("preflightSent", true);
                  window.parent.dispatchEvent(
                    new CustomEvent("ChatbotTokenReceived"),
                    {}
                  );
                  this.SendEncryptedCodeNewAccount();
                }
              }
              if (
                activity.name === "webchat/end_join" &&
                activity.from.role === "bot"
              )
                this.setState({ disabled: false });

              if (activity.name === "handoff/queued")
                this.props.handleQueueDataRecieved(activity.value);

              if (activity.name === "handoff/Dequeued")
                this.props.handleDequeued(activity.value);
            }

            if (activity && activity.locale && activity.from.role === "bot") {
              if (this.props.showedIntroCard) {
                this.props.changeLanguage(activity.locale);
                dispatch({
                  type: "WEB_CHAT/SET_LANGUAGE",
                  payload: { language: activity.locale },
                });
              } else {
                this.props.handleShowedIntroCard();
                activity.locale = this.props.language;
              }
            }

            if (
              activity &&
              activity.attachments &&
              activity.channelData &&
              activity.channelData.thumbnails
            ) {
              action.payload.activity.attachments = activity.attachments.map(
                (attachment, index) => ({
                  ...attachment,
                  contentUrl:
                    activity.channelData.thumbnails[index] ||
                    attachment.contentUrl,
                })
              );
            }

            break;
          case "DIRECT_LINE/DISCONNECT_REJECTED":
          case "DIRECT_LINE/DISCONNECT":
            break;
          case "DIRECT_LINE/DISCONNECT_FULFILLED":
            this.fetchToken(true);
            break;
          case "DIRECT_LINE/CONNECTION_STATUS_UPDATE":
            if (!!action.payload && !!action.payload.connectionStatus) {
              if (
                action.payload.connectionStatus ===
                  DirectLineConnectionStatus.ExpiredToken ||
                action.payload.connectionStatus ===
                  DirectLineConnectionStatus.FailedToConnect
              ) {
                this.setState({ token: null });
                localStorage.setItem("preflightSent", false);
              }
            }
            break;
          case "WEB_CHAT/START_DICTATE":
            if (!this.state.listening) this.setState({ listening: true });
            break;
          case "WEB_CHAT/STOP_DICTATE":
            if (this.state.listening) this.setState({ listening: false });
            break;
          default:
            break;
        }
        return next(action);
      }
    );
    return store;
  };

  injectLastActivityResource = (lastActivity) => {
    if (!lastActivity || !lastActivity.resources || lastActivity.role !== "bot")
      return;
    let domElement = document.querySelectorAll('[role="list"]');
    if (domElement.length == 0 || domElement[0].childElementCount == 0) return;
    domElement[0].lastElementChild.setAttribute(
      "resources",
      JSON.stringify(lastActivity.resources)
    );
    if (!lastActivity.suggestedActionsResources) return;
    let suggestedActionsElement = document
      .evaluate("//span[contains(., 'Suggested Actions')]", document)
      .iterateNext().parentElement;
    if (suggestedActionsElement != undefined)
      suggestedActionsElement.setAttribute(
        "resources",
        JSON.stringify(lastActivity.suggestedActionsResources)
      );
  };
  handlePasswordSubmit = () => {
    this.hasSubmittedPassword = true;
  };
  // Check Language Direction
  checkLanguageDirection = (lang) => {
    let ul = document.querySelector('ul[role="list"]');
    if (ul) {
      let lastLi = document.querySelector('ul[role="list"]').lastChild;
      let lastLiContent = lastLi.getElementsByClassName(
        "webchat__bubble__content"
      )[0];
      if (lastLi && lastLiContent) {
        lastLiContent.style.direction = lang !== "ar-jo" ? "ltr" : "rtl";
        lastLiContent.style.textAlign = lang !== "ar-jo" ? "left" : "right";
      }
      let allPara = document.querySelectorAll("p");
      let arab = /[\u0600-\u06FF]/;
      for (let index = 0; index < allPara.length; index++) {
        arab.test(allPara[index].textContent)
          ? (allPara[index].style.textAlign = "right")
          : (allPara[index].style.textAlign = "left");
      }
    }
  };

  handleCustomButtonDesign = (id) => {
    let ul = document.querySelector('ul[role="list"]');
    if (ul) {
      let lastLi = ul.lastChild;
      if (ul && lastLi) lastLi.classList.add(id);
    }
  };

  // Handle Scroll ToTop Item
  handleScrollToTopItem = () => {
    setTimeout(() => {
      let allMessages = document.querySelector('ul[role="list"]');
      if (allMessages) {
        let lastChild = allMessages.lastChild;
        if (!!lastChild) {
          //console.log("allMessages ", allMessages)
          allMessages.scrollY = lastChild.offsetTop;
          console.log("allMessages.scrollY ", allMessages.scrollY);

          // lastChild.scrollIntoView();
          // lastChild.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
          // allMessages.scrollTop = lastChild.offsetTop - allMessages.offsetTop;
          //allMessages.scrollTop = lastChild.offsetTop - allMessages.scrollTop;
          //allMessages.scrollTop = lastChild.offsetTop;
          //  document.querySelectorAll(".css-y1c0xs")[0].scrollY = lastChild.offsetTop;
          // console.log("document.documentElement.scrollTop ", document.querySelectorAll(".css-y1c0xs")[0].scrollY)
          // console.log("allMessages.scrollTop ", allMessages.scrollTop)
          // console.log("lastChild.scrollTop ", lastChild.offsetTop)
        }
      }
    }, 100);
  };

  createTokenForExistingConversation = async (conversationId, botId = "") => {
    const response = await fetch(
      process.env.REACT_APP_DIRECTLINE_URL_RECONNECT + conversationId,
      {
        method: "GET",
        headers: {
          Authorization: process.env.REACT_APP_DIRECTLINE_KEY,
          "Content-Type": "text/plain",
        },
      }
    ).catch(function() {
      var detail = { detail: { botId: botId } };
      var event = new CustomEvent("postActivityRejected", detail);
      window.parent.dispatchEvent(event);
      return;
    });

    var resp = await response.json();
    if (resp.error !== undefined) {
      // this.sendErrorToBE(
      //   4,
      //   `Agent could not connect to existing conversation: ${this.props.searchParameters} - ${conversationId}`,
      //   `Agent restore failed ${this.props.searchParameters}`,
      //   "Agent Webchat"
      // );
      return await this.createTokenForNewConversation(conversationId, botId);
    }
    return resp;
  };

  createTokenForNewConversation = async (botId) => {
    const response = await fetch(process.env.REACT_APP_DIRECTLINE_URL, {
      method: "POST",
      headers: {
        Authorization: process.env.REACT_APP_DIRECTLINE_KEY, // 'bearer p4qFrtLTEAk.tJ2TzlhwrtMlwNBUs17x70BIIfz5HpDV5S4Mcc8fJEc',//
        "Content-Type": "text/plain",
      },
    }).catch(function() {
      var detail = { detail: { botId: botId } };
      var event = new CustomEvent("postActivityRejected", detail);
      window.parent.dispatchEvent(event);
      return;
    });
    return await response.json();
  };
  componentDidUpdate(prevProps) {
    this.adjustCheckbox();
    this.adjustInputField();
    this.adjustSendButton();
    //this.adjustMicrophoneButton();
    this.handleCustomButtonDesign("subMenu");
    this.handleCustomButtonDesign("confirmActions");
    this.handleLinks();

    // if (prevProps && prevProps.language.toLocaleLowerCase() !== this.props.language.toLocaleLowerCase()) {
    // 	setTimeout(() => {
    // 		var eventObj = {
    // 			type: 'WEB_CHAT/SEND_EVENT',
    // 			payload: {
    // 				name: 'webchat/language_change',
    // 				value: { language: this.props.language },
    // 				language: this.props.language
    // 			},
    // 			locale: this.props.language
    // 		};
    // 		this.state.store.dispatch(eventObj);
    // 	}, 50)
    // }
    this.injectLastActivityResource(this.state.lastActivity);

    this.changeNewMessagesBtnText();
    //this.handleScrollToTopItem();
  }

  handleLinks() {
    const links = document.querySelectorAll("a");
    if (links && links.length > 0) {
      for (let index = 0; index < links.length; index++) {
        if (!links[index].getAttribute("data-link")) {
          links[index].addEventListener(
            "click",
            function(e) {
              e.preventDefault();
              window.parent.dispatchEvent(
                new CustomEvent("OpenLink", {
                  bubbles: true,
                  detail: { href: links[index].href },
                })
              );
            },
            false
          );
          links[index].setAttribute("data-link", true);
        }
      }
    }
  }

  clearToken = () => {
    localStorage.removeItem("botToken");
    // this.setState({ token });
  };

  // Change New Messages Btn Text
  changeNewMessagesBtnText = () => {
    let scrollElem = document.querySelectorAll(".css-y1c0xs")[0];
    if (scrollElem) {
      scrollElem.addEventListener("scroll", () => {
        let newMessagesBtn = document.getElementsByClassName("css-1m1alj7");
        if (newMessagesBtn[0]) newMessagesBtn[0].innerText = "↓";
      });
    }
  };
  checkSessionEndAfterTenMinutes = () => {
    const lastActivityTimeThenClearSession = localStorage.getItem(
      "lastActivityTimeThenClearSession"
    );
    console.log(
      lastActivityTimeThenClearSession,
      "lastActivityTimeThenClearSession"
    );

    if (!lastActivityTimeThenClearSession) {
      localStorage.setItem("lastActivityTimeThenClearSession", Date.now());
    }
    if (
      lastActivityTimeThenClearSession &&
      +lastActivityTimeThenClearSession + 10 * 60 * 1000 < Date.now()
    ) {
      localStorage.removeItem("lastActivityTimeThenClearSession");
      localStorage.removeItem("conversationId");
      localStorage.removeItem("botToken");
      localStorage.removeItem("preflightSent");
      localStorage.setItem("lastActivityTimeThenClearSession", Date.now());
    }
  };

  componentDidMount() {
    // Select all <select> elements with the class 'your-class-name'
    this.checkSessionEndAfterTenMinutes();
    // this.setUpSpeechService();
    this.getCustomerCodeAndSendIt();

    if (!this.state.token) {
      this.getCustomerCodeAndSendIt();
      // this.fetchToken();
      // this.createTokenForExistingConversation();
      this.getToken();
    }
    this.setLinkOnClick();
  }

  setLinkOnClick = () => {
    document.addEventListener("click", function(e) {
      if (e.target.localName == "a" && e.target.href.length) {
        e.preventDefault();
        window.parent.dispatchEvent(
          new CustomEvent("OpenLink", {
            bubbles: true,
            detail: { href: e.target.href },
          })
        );
        return false;
      }
    });
  };
  // componentWillUnmount() {
  // 	if (localStorage.getItem('botToken'))
  // 		this.clearToken();
  // }

  playReceivedMessageSound = () => {
    if (!this.props.soundMuted) {
      try {
        if (!window.audioObject) {
          window.audioObject = new Audio(
            "../build/assets/audio/unconvinced.mp3"
          );
          window.audioObject.mute = true;
          window.audioObject.volume = 0.7;
          window.AudioContextObject = new (window.AudioContext ||
            window.webkitAudioContext)();
          window.AudioContextSource = window.AudioContextObject.createMediaElementSource(
            window.audioObject
          );
          window.AudioContextSource.connect(
            window.AudioContextObject.destination
          );
        }
      } catch (error) {
        console.log("Audio is not supported in this browser");
      }

      if (window.audioObject !== undefined) {
        try {
          var pr = window.audioObject.play();
          window.audioObject.mute = false;
          if (!!pr) {
            pr.then(function() {
              // Automatic playback started!
            }).catch(function(error) {
              try {
                window.focus();
                var pr2 = window.audioObject.play();
                window.audioObject.mute = false;
                if (!!pr2) {
                  pr2
                    .then(function() {
                      // Automatic playback started!
                    })
                    .catch(function(error) {
                      //console.log("User needs to interact to enable custom audio")
                    });
                }
              } catch (error) {
                console.log(error);
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.token && !nextProps.token) {
      const store = this.getStore();
      this.setState({ store });
    }
  }

  adjustImage() {
    let imageNode = document.getElementsByClassName("ac-image");
    document.getElementById("card2").style.display = "block";
    for (let i = 0; i < imageNode.length; i++) {
      if (
        imageNode[i].src ===
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ1Tort3a_IQFnYdmtLtmU7rEMJGz8Lsc5soA&usqp=CAU"
      ) {
        let node = document.getElementsByClassName("rccs")[0];
        domtoimage
          .toPng(node)
          .then(function(dataUrl) {
            imageNode[i].src = dataUrl;
            document.getElementById("card2").style.display = "none";
          })
          .catch(function(error) {
            console.error("oops, something went wrong!", error);
          });
      }
    }
  }

  adjustCheckbox() {
    // "ac-choiceSetInput-multiSelect"
    let singleSelect = document.getElementsByClassName("ac-toggleInput");
    for (let x = 0; x < singleSelect.length; x++) {
      singleSelect[x].style.marginBottom = "7px";
      let input = singleSelect[x].children[0];
      input.classList.add("option-input");
    }

    let multiSelect = document.getElementsByClassName(
      "ac-choiceSetInput-multiSelect"
    );
    for (let i = 0; i < multiSelect.length; i++) {
      let baseEle = multiSelect[i];
      for (let j = 0; j < baseEle.children.length; j++) {
        baseEle.children[j].classList.add("radiobtn");
        if (this.props.language.slice(0, 2) === "ar") {
          baseEle.children[j].classList.add("radiobtnrtl");
        } else {
          baseEle.children[j].classList.remove("radiobtnrtl");
        }
        baseEle.children[j].children[0].addEventListener("click", (e) => {
          if (e.target.checked) {
            baseEle.children[j].children[2].classList.add("radio-focus");
          } else {
            baseEle.children[j].children[2].classList.remove("radio-focus");
          }
        });
      }
    }

    let radioSelect = document.querySelectorAll(
      ".ac-choiceSetInput-expanded:not(.radbtnConverted)"
    );
    for (let i = 0; i < radioSelect.length; i++) {
      let radioEle = radioSelect[i];
      for (let j = 0; j < radioEle.children.length; j++) {
        if (this.props.language.slice(0, 2) === "ar") {
          radioEle.children[j].classList.add("radbtnrtl");
        } else {
          radioEle.children[j].classList.remove("radbtnrtl");
        }
        radioEle.children[j].classList.add("radbtn");
        radioEle.children[j].children[0].addEventListener("change", (e) => {
          for (let k = 0; k < radioEle.childElementCount; k++) {
            if (radioEle.childNodes[k].firstElementChild.checked) {
              radioEle.children[k].children[2].classList.add("radbtn-focus");
            } else {
              radioEle.children[k].children[2].classList.remove("radbtn-focus");
            }
          }
        });
      }
      radioEle.classList.add("radbtnConverted");
    }
  }

  adjustInputField() {
    let elementContainer = document.getElementsByClassName("ac-adaptiveCard");
    for (let j = 0; j < elementContainer.length; j++) {
      let temb = document.getElementsByClassName("ac-input-container")[0];
      if (elementContainer[j].contains(temb)) {
        elementContainer[j].style.backgroundColor = "white ";
      }
    }

    let containers = document.getElementsByClassName("ac-input-container");
    for (let i = 0; i < containers.length; i++) {
      let tembEle = containers[i].getElementsByTagName("input");
      if (
        tembEle.length &&
        (tembEle[0].type === "text" || tembEle[0].type === "date")
      ) {
        containers[i].classList.add("du-chatbox");
        let valOfPlaceHolder = tembEle[0].getAttribute("placeholder");
        tembEle[0].setAttribute("placeholder", "");
        let span = document.createElement("span");
        let newLabel = document.createElement("LABEL");
        span.classList.add("bar");
        newLabel.classList.add("input-label");
        newLabel.innerHTML =
          tembEle[0].type === "text" ? valOfPlaceHolder : "Date";

        if (valOfPlaceHolder === "password") tembEle[0].type = "password";
        if (tembEle[0].type === "date") {
          newLabel.style.display = "none";
        }

        tembEle[0].addEventListener("focus", (event) => {
          if (tembEle[0].type === "date") {
            newLabel.style.display = "block";
          }
          if (tembEle[0].type === "date") {
            newLabel.classList.add("input-label-focus-date");
          } else {
            newLabel.classList.add("input-label-focus");
          }
          span.classList.add("bar-focused");
        });
        tembEle[0].addEventListener("blur", (event) => {
          if (tembEle[0].type === "date") {
            newLabel.style.display = "none";
          }
          if (tembEle[0].value) return;
          if (tembEle[0].type === "date") {
            newLabel.classList.remove("input-label-focus-date");
          } else {
            newLabel.classList.remove("input-label-focus");
          }

          span.classList.remove("bar-focused");
        });
        if (tembEle[0].type === "text" || tembEle[0].type === "password") {
          containers[i].append(span);
        }
        containers[i].append(newLabel);
      } else if (tembEle.length && tembEle[0].type === "checkbox") {
        //containers[i].classList.add('check-chat');
      }
    }
  }

  createDuSendButton() {
    let duSendButton = document.getElementById("duwebchatsendbutton");
    if (!!duSendButton) {
      duSendButton.parentNode.removeChild(duSendButton);
    }

    var btnSend = document.createElement("button");
    btnSend.addEventListener("click", this.handleSendButton.bind(this));
    btnSend.id = "duwebchatsendbutton";
    btnSend.className = "duwebchatsendbutton";
    btnSend.innerHTML = "<span class='icon-send'></span>";
    btnSend.style.paddingRight = "15px";
    btnSend.style.paddingLeft = "10px";
    btnSend.style.borderRadius = "0px !important";
    return btnSend;
  }

  showRefresh = () => {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 500);
  };

  showLoader() {
    this.setState({ isLoadingClick: true });
  }

  createDuMicButton() {
    let duMicButton = document.getElementById("dumicbtn");
    if (!!duMicButton) {
      duMicButton.parentNode.removeChild(duMicButton);
    }

    var btnMic = document.createElement("button");
    btnMic.addEventListener("click", this.handleMicrophoneButton.bind(this));
    btnMic.id = "dumicbtn";
    btnMic.innerHTML = "<span class='icon-record'></span>";
    // btnMic.innerHTML = '<svg height="28" viewBox="0 0 34.75 46" width="28"><path className="a" d="M29.75,23v6.36a7,7,0,0,1-.56,2.78,7.16,7.16,0,0,1-3.8,3.8,7,7,0,0,1-2.78.56H18.5v2.25H23V41H11.75v-2.25h4.5V36.5h-4.11a7,7,0,0,1-2.78-.56,7.16,7.16,0,0,1-3.8-3.8,7,7,0,0,1-.56-2.78V23h2.25v6.36a4.72,4.72,0,0,0,.39,1.9,4.78,4.78,0,0,0,2.6,2.6,4.72,4.72,0,0,0,1.9.39h10.47a4.72,4.72,0,0,0,1.9-.39,4.78,4.78,0,0,0,2.6-2.6,4.72,4.72,0,0,0,.39-1.9V23Zm-18,5.62a1.13,1.13,0,0,0,1.13,1.13h9a1.13,1.13,0,0,0,1.12-1.13V8.38a1.13,1.13,0,0,0-1.12-1.13h-9a1.13,1.13,0,0,0-1.13,1.13Zm1.13,3.38a3.41,3.41,0,0,1-1.32-.26,3.31,3.31,0,0,1-1.8-1.8,3.41,3.41,0,0,1-.26-1.32V8.38a3.41,3.41,0,0,1,.26-1.32,3.31,3.31,0,0,1,1.8-1.8,3.41,3.41,0,0,1,1.32-.26h9a3.4,3.4,0,0,1,1.31.26,3.31,3.31,0,0,1,1.8,1.8,3.41,3.41,0,0,1,.26,1.32v20.24a3.41,3.41,0,0,1-.26,1.32,3.31,3.31,0,0,1-1.8,1.8,3.4,3.4,0,0,1-1.31.26Z"></path></svg>';
    btnMic.className = !this.state.listening
      ? "dumicbtn"
      : "dumicbtn dumicbtnon";
    btnMic.style.borderRadius = "0px !important";
    return btnMic;
  }

  handleMicrophoneButton(e) {
    if (!this.state.listening) this.startListening();
    else this.stopListening();
  }

  handleSendButton(e) {
    this.state.store.dispatch({
      type: "WEB_CHAT/SUBMIT_SEND_BOX",
      payload: {},
    });
  }

  startListening() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      let mess = "";
      if (this.props.language.slice(0, 2) === "ar") {
        mess = "الرسا~ل الصوتية غير مدعومة في متصفحك";
      } else {
        mess = "Speech is not supported in your browser";
      }
      alert(mess);
      return;
    }
    this.state.store.dispatch({
      type: "WEB_CHAT/STOP_SPEAKING",
      payload: {},
    });

    this.state.store.dispatch({
      type: "WEB_CHAT/START_DICTATE",
      payload: {},
    });
  }

  stopListening() {
    this.state.store.dispatch({
      type: "WEB_CHAT/STOP_DICTATE",
      payload: {},
    });
  }

  adjustMicrophoneButton() {
    var mic = document.getElementById("dumicbtn");
    if (!mic) return;
    if (this.state.listening) {
      if (!mic.classList.contains("dumicbtnon")) {
        mic.classList.add("dumicbtnon");
      }
    } else {
      if (mic.classList.contains("dumicbtnon")) {
        mic.classList.remove("dumicbtnon");
      }
    }
  }

  adjustSendButton() {
    let mains = document.getElementsByClassName("main")[0];
    if (!mains) return;

    if (this.props.language.slice(0, 2) === "ar") {
      mains.style.direction = "rtl";
    } else {
      mains.style.direction = "ltr";
    }

    var duSendButton = this.createDuSendButton(
      this.props.language.slice(0, 2) === "ar" ? "إرسال" : "Send"
    );
    if (!duSendButton) return;

    // var duMicButton = this.createDuMicButton();
    // if (!duMicButton) return;

    // mains.appendChild(duMicButton);
    mains.appendChild(duSendButton);
  }

  fetchToken = async (force) => {
    if (!this.state.token || !!force) {
      const response = await fetch(process.env.REACT_APP_DIRECTLINE_URL, {
        method: "POST",
        headers: {
          Authorization: process.env.REACT_APP_DIRECTLINE_KEY, // 'bearer p4qFrtLTEAk.tJ2TzlhwrtMlwNBUs17x70BIIfz5HpDV5S4Mcc8fJEc',//
          "Content-Type": "text/plain",
        },
      }).catch(function() {
        // Handle error if needed.
        return;
      });
      const { token, conversationId, ...res } = await response.json();
      localStorage.setItem("botToken", token);
      localStorage.setItem("conversationId", conversationId);

      this.setState({ token });
    }
  };
  getToken = async (force) => {
    const {
      token = undefined,
      // searchParameters: { Id },
    } = this.state;
    if (!token || !!force) {
      let cachedToken = localStorage.getItem("botToken");
      let resp = undefined;
      if (!!cachedToken & !force) {
        this.setState({ token: cachedToken });
        return;
      }
      if (
        localStorage.getItem("conversationId") !== undefined &&
        localStorage.getItem("conversationId") !== ""
      ) {
        resp = await this.createTokenForExistingConversation(
          localStorage.getItem("conversationId")
        );
      } else {
        // resp = await this.createTokenForNewConversation(Id);
      }

      localStorage.setItem("conversationId", resp.conversationId);
      // localStorage.setItem("token" + Id, resp.token);
      localStorage.setItem("botToken", resp.token);

      this.setState({ token: resp.token });

      // this.raiseEventToWindow("webchatTokenRecieved", Id, {
      //   tokenResponse: resp,
      // });
      return resp.token;
    }
  };
  // setUpSpeechService = async () => {
  //   try {
  //     const webSpeechPonyfillFactoryCognitive = await createCognitiveServicesSpeechServicesPonyfillFactory(
  //       {
  //         region: process.env.REACT_APP_SPEECH_SERVICE_REGION,
  //         subscriptionKey: process.env.REACT_APP_SPEECH_SERVICE_KEY,
  //       }
  //     );
  //     this.setState(() => ({
  //       webSpeechPonyfillFactory: webSpeechPonyfillFactoryCognitive,
  //     }));
  //   } catch (e) {
  //     console.log("Speech service is not supported in this browser!: " + e);
  //   }
  // };

  adjustSendButtonActions(textOfSendButton, colorOfSendButton, fontWeight) {
    let actionElements = document.getElementsByClassName("css-1mq10jz");
    let sendButton = actionElements ? actionElements[0] : null;
    let attachButton = actionElements ? actionElements[1] : null;
    if (sendButton) sendButton.style.transform = "rotate(210deg)";
    if (attachButton) {
      attachButton.innerHTML = textOfSendButton;
      attachButton.style.color = colorOfSendButton;
      attachButton.style.fontFamily = "inherit";
      attachButton.style.fontWeight = fontWeight;
    }
  }

  disableAllButtons() {
    var buttons = document.querySelectorAll(".ac-pushButton");

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = true;
      buttons[i].classList.add("disabled");
      if (!buttons[i].classList.contains("disabled")) {
        buttons[i].classList.add("disabled");
      }
    }
  }

  render() {
    let mainLang = this.props.language.slice(0, 2);
    const gender = process.env.REACT_APP_SPEECH_GENDER;
    const styleSet = getWebChatStyleSet(
      this.props.webChatConfiguration,
      this.props.language
    );
    const {
      props: { className, language },
      state: {
        activityMiddleware,
        store,
        token,
        webSpeechPonyfillFactory,
        disabled,
      },
    } = this;
    let overlayClass = disabled
      ? "disabled-overlay-shown"
      : "disabled-overlay-shown disabled-overlay-hidden";
    let loading = this.state.isRestartClick ? (
      <div className={`${className || ""} connect-spinner`}>
        <div className="content">
          <div className="icon iconnnn">
            <div class="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <p>{this.props.literals.waitWhileConnecting}</p>
        </div>
      </div>
    ) : (
      ""
    );
    let refresh = this.state.isLoading ? <Loading></Loading> : "";
    return token ? (
      <div
        className={
          overlayClass == "disabled-overlay-shown"
            ? "body-container overflow-visiable"
            : "body-container"
        }
      >
        <div className={overlayClass}></div>
        {/* <Card ccv={this.state.ccv} cardNo={this.state.cardNo} date={this.state.date} /> */}
        {refresh}
        {loading}
        <ModalConfirm
          openModalFun={this.openModalFun}
          openModal={this.state.openModal}
          closeModalFun={this.closeModalFun}
          language={this.props.language}
        />

        <ReactWebChat
          className={`${className || ""} webchat`}
          directLine={this.createDirectLine(token)}
          webSpeechPonyfillFactory={this.state.webSpeechPonyfillFactory}
          store={store}
          styleSet={styleSet}
          locale={this.props.language}
          activityMiddleware={activityMiddleware}
          dir={mainLang === "ar" ? "rtl" : "ltr"}
          selectVoice={(voices, activity) => {
            var voice;
            if (activity.locale.indexOf("ar") >= 0) {
              voice = voices.find(
                (e) => e.lang.indexOf("ar-AE") >= 0 && e.gender === "Male"
              );
              // voice = voices[5];
            } else {
              voice = voices.find(
                (e) => e.lang.indexOf("en-US") >= 0 && e.gender === "Male"
              );
              // voice = voices[117];
            }
            if (!voice) voice = voices[0];
            return voice;
          }}
        />
      </div>
    ) : (
      // <div className={`${className || ""} connect-spinner`}>
      //   <div className="content">
      //     <div className="icon">
      //       {/* <img src={botAvatar} alt={''} /> */}
      //       <img src={loader} alt={""} />
      //     </div>
      //     <p>{this.props.literals.waitWhileConnecting}</p>
      //   </div>
      // </div>
      ""
    );
  }
}

WebChat.propTypes = {
  className: PropTypes.string.isRequired,
  token: PropTypes.string,
  language: PropTypes.string.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  showedIntroCard: PropTypes.bool.isRequired,
  handleShowedIntroCard: PropTypes.func.isRequired,
};
const mapStateToProps = ({ literals }) => ({
  literals,
});

export default connect(mapStateToProps)(WebChat);
